import React, { Component } from 'react';
import Body from './Body';
import Header from './Header';

class Page404 extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidMount() {
        // require('../../assets/scss/style.scss')
    }
    render() {
        return (
            <>
                <Header {...this.props} type='back' title='Page Not Found' />
                <Body {...this.props} />
            </>
        )
    }
}
export default Page404;